import { c as _c } from "react/compiler-runtime";
import { Trans, useTranslation } from 'react-i18next';
import React from 'react';
import { Link } from '@/components/links';
import IconPhone from '@/assets/icons/heroIcons/Phone.svg';
import IconMail from '@/assets/icons/heroIcons/Mail.svg';
import IconChat from '@/assets/icons/heroIcons/Chat.svg';
import { SectionHeadline } from '@/components/SectionHeadline';
import { CallMeForm } from '@/components/CallMeForm';
import { Text } from '@/components/typography';
import { CONTACT_EMAIL } from '@/constants/contacts';
import { LINKS } from '@/constants/links';
import { safeOpenJarabot } from '@/utils/jarabot';
import { Button } from '@/components/buttons';
export function Contact() {
  const $ = _c(68);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["retention"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  let t1;
  if ($[1] !== t) {
    t1 = t("contact.title");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <SectionHeadline className="mb-4 lg:mb-6" anchorKey="contact.title">{t1}</SectionHeadline>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t("contact.text");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <Text variant="p2" className="mb-12 text-center text-gray-800 lg:mb-16">{t3}</Text>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <IconPhone className="h-8 w-8 text-blue-500 lg:h-10 lg:w-10" />;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t) {
    t6 = t("contact.items.2.title");
    $[10] = t;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t6) {
    t7 = <h3 className="text-center font-semibold lg:text-xl">{t6}</h3>;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t) {
    t8 = t("contact.items.2.text");
    $[14] = t;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t8) {
    t9 = <p className="text-light-gray-500 text-center text-sm">{t8}</p>;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t) {
    t10 = t("contact.items.2.title");
    $[18] = t;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t10) {
    t11 = <div className="my-4 w-full"><CallMeForm type="REVOLVING_LOAN_CANCELLATION_REQUEST" description={t10} hideRetentionButton={true} /></div>;
    $[20] = t10;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <Link testId="informationMemorandum" analyticsParam="informationMemorandum" to={LINKS().informationMemorandum} />;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== t) {
    t13 = <p className="text-light-gray-500 text-center text-xs"><Trans t={t} i18nKey="contact.items.2.conditions">{t12}</Trans></p>;
    $[23] = t;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== t11 || $[26] !== t13 || $[27] !== t7 || $[28] !== t9) {
    t14 = <div className="flex w-full shrink-0 flex-col items-center justify-center gap-2 rounded-2xl bg-white p-4 lg:order-1 lg:max-w-[29.25rem] lg:rounded-4xl lg:p-8 lg:px-12">{t5}{t7}{t9}{t11}{t13}</div>;
    $[25] = t11;
    $[26] = t13;
    $[27] = t7;
    $[28] = t9;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <IconMail className="h-8 w-8 text-blue-500 lg:h-10 lg:w-10" />;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== t) {
    t16 = t("contact.items.1.title");
    $[31] = t;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== t16) {
    t17 = <h3 className="font-semibold lg:text-xl">{t16}</h3>;
    $[33] = t16;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  let t18;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <Link to={`mailto:${CONTACT_EMAIL}`} analyticsParam="retentionMail" testId="retentionMail">{CONTACT_EMAIL}</Link>;
    $[35] = t18;
  } else {
    t18 = $[35];
  }
  let t19;
  if ($[36] !== t) {
    t19 = t("contact.items.1.text");
    $[36] = t;
    $[37] = t19;
  } else {
    t19 = $[37];
  }
  let t20;
  if ($[38] !== t19) {
    t20 = <p className="text-light-gray-500 text-sm">{t19}</p>;
    $[38] = t19;
    $[39] = t20;
  } else {
    t20 = $[39];
  }
  let t21;
  if ($[40] !== t17 || $[41] !== t20) {
    t21 = <div className="flex w-full flex-1 flex-col items-center justify-center gap-4 rounded-2xl bg-white p-4 text-center lg:order-0 lg:rounded-4xl lg:p-8">{t15}{t17}{t18}{t20}</div>;
    $[40] = t17;
    $[41] = t20;
    $[42] = t21;
  } else {
    t21 = $[42];
  }
  let t22;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <IconChat className="h-8 w-8 text-blue-500 lg:h-10 lg:w-10" />;
    $[43] = t22;
  } else {
    t22 = $[43];
  }
  let t23;
  if ($[44] !== t) {
    t23 = t("contact.items.3.title");
    $[44] = t;
    $[45] = t23;
  } else {
    t23 = $[45];
  }
  let t24;
  if ($[46] !== t23) {
    t24 = <h3 className="font-semibold lg:text-xl">{t23}</h3>;
    $[46] = t23;
    $[47] = t24;
  } else {
    t24 = $[47];
  }
  let t25;
  if ($[48] !== t) {
    t25 = t("contact.items.3.linkTitle");
    $[48] = t;
    $[49] = t25;
  } else {
    t25 = $[49];
  }
  let t26;
  if ($[50] !== t25) {
    t26 = <Button onClick={safeOpenJarabot} analyticsParam="retentionChatbot" testId="retentionChatbot" variant="secondary" className="!w-50">{t25}</Button>;
    $[50] = t25;
    $[51] = t26;
  } else {
    t26 = $[51];
  }
  let t27;
  if ($[52] !== t) {
    t27 = t("contact.items.3.text");
    $[52] = t;
    $[53] = t27;
  } else {
    t27 = $[53];
  }
  let t28;
  if ($[54] !== t27) {
    t28 = <p className="text-light-gray-500 max-w-52 text-sm">{t27}</p>;
    $[54] = t27;
    $[55] = t28;
  } else {
    t28 = $[55];
  }
  let t29;
  if ($[56] !== t24 || $[57] !== t26 || $[58] !== t28) {
    t29 = <div className="flex w-full flex-1 flex-col items-center justify-center gap-3 rounded-2xl bg-white p-4 text-center lg:order-3 lg:rounded-4xl lg:p-8">{t22}{t24}{t26}{t28}</div>;
    $[56] = t24;
    $[57] = t26;
    $[58] = t28;
    $[59] = t29;
  } else {
    t29 = $[59];
  }
  let t30;
  if ($[60] !== t14 || $[61] !== t21 || $[62] !== t29) {
    t30 = <div className="flex flex-col items-center justify-center gap-4 lg:flex-row lg:gap-8">{t14}{t21}{t29}</div>;
    $[60] = t14;
    $[61] = t21;
    $[62] = t29;
    $[63] = t30;
  } else {
    t30 = $[63];
  }
  let t31;
  if ($[64] !== t2 || $[65] !== t30 || $[66] !== t4) {
    t31 = <div className="px-4"><div className="mx-auto max-w-292">{t2}{t4}{t30}</div></div>;
    $[64] = t2;
    $[65] = t30;
    $[66] = t4;
    $[67] = t31;
  } else {
    t31 = $[67];
  }
  return t31;
}